/**
 * Query Key factory for all user queries.
 *
 * @module User
 */

export const userQKeys = {
  all: () => ["users"] as const,

  allWithFilters: (filters: { role?: string; serviceId?: string }) =>
    [...userQKeys.all(), { ...filters }] as const,

  partners: () => [...userQKeys.all(), "partners"] as const,
};
